import Navbar from './components/Navbar';
import Home from './routes/Home';
import Popular from './routes/Popular';
import Top from './routes/Top';
import Content from './components/Content';
import OnScreen from './routes/OnScreen';
import { Routes, Route } from "react-router-dom";
import Upcoming from './routes/Upcoming';

function App() {
  return (
    <div className="App">
      <Navbar />

      <Routes>
        <Route path={`${process.env.PUBLIC_URL}/`} element={<Home />} />
        <Route path="/" element={<Home />} />
        <Route path="/popular" element={<Popular />} />
        <Route path="/onscreen" element={<OnScreen />} />
        <Route path="/top" element={<Top />} />
        <Route path="/upcoming" element={<Upcoming />} />
        <Route path="/content/:id" element={<Content />} />


      </Routes>
    </div>
  );
}

export default App;
